import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import Layout from 'app/components/Layout/Layout';
import ErrorPage from 'app/pages/ErrorPage/ErrorPage';
import CheckEmail from 'app/pages/CheckEmail/CheckEmail';

const Login = lazy(() => import('app/pages/Login/Login'));
const ResetPassword = lazy(() => import('app/pages/ResetPassword/ResetPassword'));
const SetPassword = lazy(() => import('app/pages/SetPassword/SetPassword'));

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate replace to="login" />,
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '*',
        element: <ErrorPage text="Page not found" status={404} />,
      },
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'reset-password',
        element: <ResetPassword />,
      },
      {
        path: 'reset-password/check-email',
        element: <CheckEmail />,
      },
      {
        path: ':lang/set-password',
        element: <SetPassword />,
      },
    ],
  },
]);

export default router;
